import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, isSupported, Analytics } from "firebase/analytics";

// Client-side Firebase config - only for analytics, no sensitive data
const firebaseConfig = {
  apiKey: import.meta.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: import.meta.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: import.meta.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Debug: Log the config to see what's being loaded
console.log('Firebase config:', {
  ...firebaseConfig,
  apiKey: firebaseConfig.apiKey ? '***REDACTED***' : 'MISSING'
});

// Debug environment variables
console.log('Environment variables status:', {
  NEXT_PUBLIC_FIREBASE_API_KEY: import.meta.env.NEXT_PUBLIC_FIREBASE_API_KEY ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: import.meta.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: import.meta.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_APP_ID: import.meta.env.NEXT_PUBLIC_FIREBASE_APP_ID ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID: import.meta.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: import.meta.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ? 'PRESENT' : 'MISSING',
  NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ? 'PRESENT' : 'MISSING'
});

// Validate required fields
const missingFields = [];
if (!firebaseConfig.apiKey) missingFields.push('apiKey');
if (!firebaseConfig.projectId) missingFields.push('projectId');
if (!firebaseConfig.appId) missingFields.push('appId');
if (!firebaseConfig.measurementId) missingFields.push('measurementId');

if (missingFields.length > 0) {
  console.error('Missing Firebase configuration fields:', missingFields);
}

// Initialize Firebase only if all required fields are present
let app: any;
let analytics: Analytics | undefined;

if (missingFields.length === 0) {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
  console.log('Firebase app initialized successfully');

  if (typeof window !== "undefined") {
    isSupported().then((supported) => {
      if (supported) {
        try {
          analytics = getAnalytics(app);
          console.log('Firebase Analytics initialized successfully');
        } catch (error) {
          console.error('Failed to initialize Firebase Analytics:', error);
        }
      } else {
        console.warn('Firebase Analytics not supported in this browser');
      }
    }).catch((error) => {
      console.error('Error checking Analytics support:', error);
    });
  }
} else {
  console.error('Cannot initialize Firebase: Missing required configuration fields');
}

export { app, analytics };
